<template>
  <div
    class="dropdown"
  >
    <button
      class="btn btn-link dropdown-toggle"
      type="button"
      id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      Options
    </button>
    <div
      class="dropdown-menu"
      aria-labelledby="dropdownMenuButton"
    >
      <a
        class="dropdown-item"
        href="#"
        v-on:click.prevent="downloadPuzzlesMetadataCSV"
      >
        Metadata for All Puzzles (CSV)
      </a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    downloadPuzzlesMetadataCSV () {
      this.$http.get(
        this.apiUrl(
          '/puzzles_as_csv', true
        ),
        {
          responseType: 'blob'
        }
      ).then((response) => {
        let headers = response.headers

        let blob = new Blob([response.bodyBlob], {
          type: headers['Content-Type']
        })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'puzzles.csv'
        link.click()
      }, this.$root.processErrors)
    }
  }
}
</script>

<style scoped>
  .dropdown {
    margin-top: 0.05rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/PuzzlesOptions.vue